/**
 * Parameters to get featured item: institutes, scholarships, programs and so on
 *
 * Used on homepage to goto featured items
 */
export const FEATURED_FILTER_URL_PARAM = 'featured=1';
